import { createAction } from '@reduxjs/toolkit';
import { SmoEnvironment } from '../../../../Models/Smo/SmoEnvironment';
import { UserRun } from '../../../../Models/User/UserRun';
import { UserWidgetSettings } from '../../../../Models/User/UserWidgetSettings';
import { Optional } from '../../../../Utils/Types';

const observeWidgetConnection = createAction('WIDGET_OBSERVE_WIDGET_CONNECTION');
const stopObservingWidgetConnection = createAction('WIDGET_STOP_OBSERVING_WIDGET_CONNECTION');
const updateSettings = createAction<UserWidgetSettings>('WIDGET_UPDATE_SETTINGS');
const updateSettingsSuccess = createAction('WIDGET_UPDATE_SETTINGS_SUCCESS');
const updateEnvironment = createAction<SmoEnvironment>('WIDGET_UPDATE_ENVIRONMENT');
const updateEnvironmentSuccess = createAction('WIDGET_UPDATE_ENVIRONMENT_SUCCESS');
const updateRun = createAction<Optional<UserRun>>('WIDGET_UPDATE_RUN');
const updateRunSuccess = createAction<Optional<UserRun>>('WIDGET_UPDATE_RUN_SUCCESS');

export default {
  observeWidgetConnection,
  stopObservingWidgetConnection,
  updateSettings,
  updateSettingsSuccess,
  updateEnvironment,
  updateEnvironmentSuccess,
  updateRun,
  updateRunSuccess
};
